"use strict";

exports.__esModule = true;
exports.LayoutTemplateCollectionContext = void 0;
var _Utils = require("../../../Utils");
/**
 * Provides a collection of layoutTemplates to consumers.
 * @component
 */
var LayoutTemplateCollectionContext = exports.LayoutTemplateCollectionContext = (0, _Utils.createEnhancedContext)({
  propName: "layoutTemplateCollection"
});